import { _UnicodeLine } from './../../fonts/pdf-standard-font';
import { _ArabicShapeRenderer } from './../../graphics/rightToLeft/text-shape';
import { _Bidirectional } from './../../graphics/rightToLeft/bidirectional';
import { PdfTextDirection } from './../../enumerator';
import { _stringToUnicodeArray, _bytesToString } from './../../utils';
export class _RtlRenderer {
    constructor() {
        this._openBracket = '(';
        this._closeBracket = ')';
    }
    _layout(line, font, rtl, wordSpace, format) {
        let result = [];
        if (font !== null && typeof font !== 'undefined' && line !== null && typeof line !== 'undefined') {
            if (font._isUnicode) {
                result = this._customLayout(line, rtl, format, font, wordSpace);
            }
            else {
                result = [];
                result[0] = line;
            }
        }
        return result;
    }
    _splitLayout(line, font, rtl, wordSpace, format) {
        let words = [];
        if (font !== null && typeof font !== 'undefined' && line !== null && typeof line !== 'undefined') {
            const system = false;
            if (!system) {
                words = this._customSplitLayout(line, font, rtl, wordSpace, format);
            }
        }
        return words;
    }
    _getGlyphIndex(line, font, glyphs) {
        glyphs = [];
        if (font !== null && typeof font !== 'undefined' && line !== null && typeof line !== 'undefined') {
            if (line.length === 0) {
                return { _result: false, _glyphIndex: glyphs };
            }
            const renderer = new _ArabicShapeRenderer();
            const text = renderer._shape(line);
            const internalFont = font._fontInternal;
            const ttfReader = internalFont._ttfReader;
            glyphs = [text.length];
            let i = 0;
            for (let k = 0, len = text.length; k < len; k++) {
                const ch = text[k];
                const glyphInfo = ttfReader._getGlyph(ch);
                if (glyphInfo !== null && typeof glyphInfo !== 'undefined') {
                    glyphs[i++] = (glyphInfo)._index;
                }
            }
        }
        const unicodeLine = new _UnicodeLine();
        unicodeLine._result = true;
        unicodeLine._glyphIndex = glyphs;
        return unicodeLine;
    }
    _customLayout(line, rtl, format, font, wordSpace) {
        if (wordSpace === null || typeof wordSpace === 'undefined') {
            let result = null;
            if (line !== null && typeof line !== 'undefined') {
                if (format !== null && typeof format !== 'undefined' && format.textDirection !== PdfTextDirection.none) {
                    const bidi = new _Bidirectional();
                    result = bidi._getLogicalToVisualString(line, rtl);
                }
            }
            return result;
        }
        else {
            let layouted = '';
            let result = [];
            if (line !== null && typeof line !== 'undefined' && font !== null && typeof font !== 'undefined') {
                if (format !== null && typeof format !== 'undefined' && format.textDirection !== PdfTextDirection.none) {
                    const renderer = new _ArabicShapeRenderer();
                    const txt = renderer._shape(line);
                    layouted = this._customLayout(txt, rtl, format);
                }
                if (wordSpace) {
                    let words = layouted.split('');
                    words = words.map((word) => this._addCharacter(font, word));
                    result = words;
                }
                else {
                    result = [];
                    result[0] = this._addCharacter(font, layouted);
                }
            }
            return result;
        }
    }
    _addCharacter(font, glyphs) {
        if (font !== null && typeof font !== 'undefined' && glyphs !== null && typeof glyphs !== 'undefined') {
            const internalFont = font._fontInternal;
            const ttfReader = internalFont._ttfReader;
            font._setSymbols(glyphs);
            glyphs = ttfReader._convertString(glyphs);
            const bytes = _stringToUnicodeArray(glyphs);
            glyphs = _bytesToString(bytes);
        }
        return glyphs;
    }
    _customSplitLayout(line, font, rtl, wordSpace, format) {
        let words = [];
        if (line !== null && typeof line !== 'undefined') {
            const reversedLine = this._customLayout(line, rtl, format);
            words = reversedLine.split('');
        }
        return words;
    }
}
